var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 9,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4458 19.0474C10.4441 19.0474 9.63203 19.8373 9.63203 20.8118V23.1643C9.63203 24.1388 10.4441 24.9287 11.4458 24.9287H21.1192C22.1209 24.9287 22.9329 24.1388 22.9329 23.1643V20.8118C22.9329 19.8373 22.1209 19.0474 21.1192 19.0474H11.4458ZM8.42285 20.8118C8.42285 19.1877 9.77627 17.8711 11.4458 17.8711H21.1192C22.7887 17.8711 24.1421 19.1877 24.1421 20.8118V23.1643C24.1421 24.7884 22.7887 26.105 21.1192 26.105H11.4458C9.77627 26.105 8.42285 24.7884 8.42285 23.1643V20.8118Z",
    fill: "#004357"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2808 14.4121C18.2961 14.4121 19.9299 12.7783 19.9299 10.7629C19.9299 8.7476 18.2961 7.11383 16.2808 7.11383C14.2654 7.11383 12.6317 8.7476 12.6317 10.7629C12.6317 12.7783 14.2654 14.4121 16.2808 14.4121ZM16.2808 15.6284C18.9679 15.6284 21.1463 13.4501 21.1463 10.7629C21.1463 8.07581 18.9679 5.89746 16.2808 5.89746C13.5936 5.89746 11.4153 8.07581 11.4153 10.7629C11.4153 13.4501 13.5936 15.6284 16.2808 15.6284Z",
    fill: "#004357"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.ff043ba1f7ab3498756676b27f20a288.svg";
export { ForwardRef as ReactComponent };